@if (hero().widget; as widget) {
  <div class="hero-widget">
    <sc-placeholder name="widget-dynamic" [rendering]="widget" />
  </div>
} @else {
  <div
    class="hero-widget__placeholder"
    [class.hero-widget__placeholder--rebranding]="hasEssentRebranding()"
  >
    <span>+ Add a widget</span>
  </div>
}
